import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

export const CAR_RUNNER_SCORE_SUBJECT = "CarRunnerScore" as const;

export function setCarRunnerScorePermissions(user: User, builder: AbilityBuilder<AppAbility>): void {
  const { can } = builder;

  if (user.roles.includes(SubjectRoles.Developer)) {
    can(Action.Read, CAR_RUNNER_SCORE_SUBJECT);
    can(Action.Create, CAR_RUNNER_SCORE_SUBJECT);
  }
}
